"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IVerify = exports.ISubscriberTopicMap = exports.ISubscriber = exports.IStore = exports.ISignClientEvents = exports.ISignClient = exports.IRelayer = exports.IPublisher = exports.IPairing = exports.IMessageTracker = exports.IKeyChain = exports.IJsonRpcHistory = exports.IExpirer = exports.IEngineEvents = exports.IEngine = exports.ICrypto = exports.ICore = void 0;

var _events = require("@walletconnect/events");

var _events2 = _interopRequireWildcard(require("events"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var n = /*#__PURE__*/function (_e) {
  _inherits(n, _e);

  var _super = _createSuper(n);

  function n(s) {
    var _this;

    _classCallCheck(this, n);

    _this = _super.call(this), _this.opts = s, _this.protocol = "wc", _this.version = 2;
    return _this;
  }

  return _createClass(n);
}(_events.IEvents);

exports.ICore = n;

var l = /*#__PURE__*/_createClass(function l(s, t, o) {
  _classCallCheck(this, l);

  this.core = s, this.logger = t;
});

exports.ICrypto = l;

var h = /*#__PURE__*/function (_e2) {
  _inherits(h, _e2);

  var _super2 = _createSuper(h);

  function h(s, t) {
    var _this2;

    _classCallCheck(this, h);

    _this2 = _super2.call(this), _this2.core = s, _this2.logger = t, _this2.records = new Map();
    return _this2;
  }

  return _createClass(h);
}(_events.IEvents);

exports.IJsonRpcHistory = h;

var a = /*#__PURE__*/_createClass(function a(s, t) {
  _classCallCheck(this, a);

  this.logger = s, this.core = t;
});

exports.IMessageTracker = a;

var u = /*#__PURE__*/function (_e3) {
  _inherits(u, _e3);

  var _super3 = _createSuper(u);

  function u(s, t) {
    var _this3;

    _classCallCheck(this, u);

    _this3 = _super3.call(this), _this3.relayer = s, _this3.logger = t;
    return _this3;
  }

  return _createClass(u);
}(_events.IEvents);

exports.IPublisher = u;

var g = /*#__PURE__*/function (_e4) {
  _inherits(g, _e4);

  var _super4 = _createSuper(g);

  function g(s) {
    _classCallCheck(this, g);

    return _super4.call(this);
  }

  return _createClass(g);
}(_events.IEvents);

exports.IRelayer = g;

var p = /*#__PURE__*/_createClass(function p(s, t, o, w) {
  _classCallCheck(this, p);

  this.core = s, this.logger = t, this.name = o;
});

exports.IStore = p;

var I = /*#__PURE__*/_createClass(function I() {
  _classCallCheck(this, I);

  this.map = new Map();
});

exports.ISubscriberTopicMap = I;

var d = /*#__PURE__*/function (_e5) {
  _inherits(d, _e5);

  var _super5 = _createSuper(d);

  function d(s, t) {
    var _this4;

    _classCallCheck(this, d);

    _this4 = _super5.call(this), _this4.relayer = s, _this4.logger = t;
    return _this4;
  }

  return _createClass(d);
}(_events.IEvents);

exports.ISubscriber = d;

var x = /*#__PURE__*/_createClass(function x(s, t) {
  _classCallCheck(this, x);

  this.core = s, this.logger = t;
});

exports.IKeyChain = x;

var E = /*#__PURE__*/function (_e6) {
  _inherits(E, _e6);

  var _super6 = _createSuper(E);

  function E(s, t) {
    var _this5;

    _classCallCheck(this, E);

    _this5 = _super6.call(this), _this5.core = s, _this5.logger = t;
    return _this5;
  }

  return _createClass(E);
}(_events.IEvents);

exports.IExpirer = E;

var m = /*#__PURE__*/_createClass(function m(s, t) {
  _classCallCheck(this, m);

  this.logger = s, this.core = t;
});

exports.IPairing = m;

var y = /*#__PURE__*/_createClass(function y(s, t) {
  _classCallCheck(this, y);

  this.projectId = s, this.logger = t;
});

exports.IVerify = y;

var v = /*#__PURE__*/function (_c) {
  _inherits(v, _c);

  var _super7 = _createSuper(v);

  function v() {
    _classCallCheck(this, v);

    return _super7.call(this);
  }

  return _createClass(v);
}(_events2["default"]);

exports.ISignClientEvents = v;

var b = /*#__PURE__*/_createClass(function b(s) {
  _classCallCheck(this, b);

  this.opts = s, this.protocol = "wc", this.version = 2;
});

exports.ISignClient = b;

var C = /*#__PURE__*/function (_i) {
  _inherits(C, _i);

  var _super8 = _createSuper(C);

  function C() {
    _classCallCheck(this, C);

    return _super8.call(this);
  }

  return _createClass(C);
}(_events2.EventEmitter);

exports.IEngineEvents = C;

var S = /*#__PURE__*/_createClass(function S(s) {
  _classCallCheck(this, S);

  this.client = s;
});

exports.IEngine = S;